import { render } from "./solana.vue?vue&type=template&id=a33fb5f6"
const script = {}

import "./solana.vue?vue&type=style&index=0&id=a33fb5f6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__